<!--商品详情-->
<template>
  <div class="news-content">
    <m-header>
      <div slot="nav"></div>
    </m-header>
    <div class="w w-full fill-full">
      <!--产品信息-->
      <div class="item-info gray-box" v-loading="loading" element-loading-text="加载中...">
        <div class="item-title" v-if="itemTitle">
          {{ itemTitle }}
        </div>
        <div class="item-time" v-if="itemTime">
          {{ itemTime }}
        </div>
        <div class="content">
          <div class="item-content" v-if="itemDetail">
            <div v-html="itemDetail"></div>
          </div>
          <div class="no-info" v-else>
            <img src="/static/images/no-data.png">
            <br>
            暂无内容数据
          </div>
        </div>
      </div>
    </div>
    <m-footer></m-footer>
    <Customer class="customerSer"></Customer>
  </div>
</template>
<script>
import MHeader from '/common/MHeader'
import MFooter from '/common/MFooter'
import Customer from '../Order/components/customerSer'
import api from '../../../common/request/request.js'

export default {
  data() {
    return {
      userId: '',
      itemTitle: '',
      itemDetail: '',
      itemTime: '',
      loading: true
    }
  },
  computed: {},
  methods: {
    // 渲染详情数据（后端 content 实体：contentTitle/contentDetail/publishTime）
    renderDetail(row) {
      row = row || {}
      this.itemTitle = row.contentTitle || ''
      this.itemDetail = this.$yxz.showHtml(row.contentDetail) || ''
      this.itemTime = row.createTime || ''
    }
  },
  components: {
    MHeader,
    MFooter,
    Customer
  },
  // 进入页面前请求详情数据
  beforeRouteEnter(to, from, next) {
    const id = to.query.newsId
    let done = false
    const finish = (cb) => {
      if (done) return
      done = true
      next(cb)
    }
    if (id) {
      api.get({
        url: '/biz/content/detail/' + id
      }).then(res => {
        finish(vm => {
          vm.renderDetail(res && res.data)
          vm.loading = false
        })
      }).catch(() => {
        finish(vm => {
          vm.loading = false
        })
      })
      // 兜底：接口长时间无响应（如非200响应未 resolve）时先进入页面展示无数据视图
      setTimeout(() => {
        finish(vm => {
          vm.loading = false
        })
      }, 12000)
    } else {
      finish(vm => {
        vm.loading = false
      })
    }
  },
  created() {
    document.title = "医小智 - 前沿资讯 - 详情"
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/style/mixin";

.news-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.w-full {
  display: flex;
  flex-direction: column;
}

.item-info {
  margin: 20px auto;
  padding: 60px;
  width: 1220px;
  max-width: calc(100% - 40px);
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;

  .gray-box {
    padding: 0;
    display: block;
  }

  .item-title {
    font-size: 28px;
    color: #424242;
    text-align: center;
    padding-bottom: 20px;
  }

  .item-time {
    font-size: 14px;
    color: #999999;
    text-align: center;
    padding-bottom: 20px;
  }

  .item-content {
    width: 100%;
    text-align: center;
    flex: 1;
  }
}

.content {
  flex: 1;
}

.no-info {
  padding: 200px 0;
  text-align: center;
  font-size: 30px;
}

</style>

<!-- 富文本由 v-html 渲染，scoped 样式无法命中，需单独非 scoped 样式 -->
<style lang="scss">
.item-content {
  img {
    max-width: 100% !important;
    height: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// newsDetail.vue?cc29f77a